// extracted by mini-css-extract-plugin
module.exports = {"link":"_39YfN","root":"_3R5Ib","wrapper":"_2QWkQ","container":"_17LNG","bottom":"_142Ik","ribbon":"_15IZU","top":"O4j_Z","label":"Re8ib"};